import MaskTitle, {MaskTitlePropTypes} from './MaskTitle';

export type {MaskTitlePropTypes};
export default MaskTitle;
